import { render, staticRenderFns } from "./BoMain.vue?vue&type=template&id=98a28b46&"
import script from "./BoMain.vue?vue&type=script&lang=js&"
export * from "./BoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BoMain.vue"
export default component.exports